import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Container } from "@mantine/core";
import ReferralTable from "@/components/tables/ReferralTable";
import Navbar from "@/components/layout/Navbar";
import { Toast } from "design-system/src/components/Toast";
import styles from "./home-page.module.scss";

function HomePage() {
  const location = useLocation();
  const [state, setState] = useState(location.state || {});

  return (
    <Navbar titleText="Console">
      <Container className={styles.homeContainer} fluid>
        <Toast
          variant="success"
          isVisible={!!state.success}
          onDismiss={() => setState({})}
        >
          Referral sent! You may now refer another patient.
        </Toast>
        <ReferralTable />
      </Container>
    </Navbar>
  );
}

export default HomePage;
